// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasOperadores_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /relatorios/vendas_operadores/lista_vendas.
 *
 * Returns a list of realised sales (compromissos with status = 'Realizado')
 * per operator/franchise, used by the "Vendas dos Operadores" report.
 */
import type { VendasOperadores_ListaRow } from './VendasOperadores_ListaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type VendasOperadores_ListaResponseDados = VendasOperadores_ListaRow[];

export type VendasOperadores_ListaResponse = ApiResponse<VendasOperadores_ListaResponseDados>;

registerResponseContract('VendasOperadores_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servico_id:                   { type: 'number',  required: true },
      servicoscategoria_id:         { type: 'number',  required: true },
      cliente_nome:                 { type: 'string',  required: true },
      compromisso_franquia_id:      { type: 'number',  required: false },
      compromisso_operador_user_id: { type: 'string',  required: false },
      total_compromisso:            { type: 'string',  required: true },
      data:                         { type: 'string',  required: true },
      servicoscategoria_nome:       { type: 'string',  required: false },
      servico_nome:                 { type: 'string',  required: false },
      franquia:                     { type: 'string',  required: false },
      operador:                     { type: 'string',  required: false },
    },
  },
})
